// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AcoesMarketing_SalvarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** ResponseContract for POST /marketing/acoes/salvar and the arquivar/restaurar actions. */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AcoesMarketing_SalvarResponseDados {
id: number
acao: string
}

export type AcoesMarketing_SalvarResponse = ApiResponse<AcoesMarketing_SalvarResponseDados>;

registerResponseContract('AcoesMarketing_SalvarResponse', {
  id:   { type: 'number',  required: true },
  acao: { type: 'string',  required: true },
})
